"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const preact_1 = require("preact");
const hooks_1 = require("preact/hooks");
const _1 = __importDefault(require("."));
const backgroundCss = (0, css_1.css) `
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));
    cursor: default;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 75px;
    pointer-events: none;
`;
const attributionCss = (0, css_1.css) `
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
`;
const containerCss = (0, css_1.css) `
    transition: opacity 150ms ease-in;
`;
const AttributionOverlay = ({ gif, isHovered, onClick, }) => {
    const hasHovered = (0, hooks_1.useRef)(isHovered);
    if (isHovered) {
        // not rendering to avoid loading the avatar until hover
        hasHovered.current = true;
    }
    return gif.user && hasHovered.current ? ((0, preact_1.h)("div", { className: containerCss, style: { opacity: isHovered ? 1 : 0 } },
        (0, preact_1.h)("div", { className: backgroundCss }),
        (0, preact_1.h)(_1.default, { gif: gif, className: attributionCss, onClick: onClick }))) : null;
};
exports.default = AttributionOverlay;
//# sourceMappingURL=overlay.js.map